define([
	"dojo/_base/declare",
	"csi/comm",
	"csi/core/ExtendedPath",
	"csi/xml",
	"csi/xml/Query"
], function(declare, comm, ExtendedPath, xml, Query) {

	return declare(null, {
		urlSeason: null,
		_urlLevel: null,

		_getRootRequest: function(/*Node*/node) {
			// summary: return request used to query for root object of view with dependencies
			if (this._urlLevel) {
				node = this.cacheView.getNode(this._urlLevel);
			} else {
				this._urlLevel = node?.$URL;
			}

			var request = this.inherited(arguments, [node]);

			// override request to search for version that matches selected season
			if (request && this.urlSeason) {
				var q = new Query().RefAttr("Season", xml.OP_EQUALS, this.urlSeason);
				request.removeParameter(comm.QUERY_URL);
				request.addParameter(comm.OPERATION, comm.OP_QUERY);
				request.addParameter("Qry.Limit.Path", xml.getUrlPath(this._urlLevel, new ExtendedPath(node.$Type).addRelationStep("Versions").toString()));
				request.setBinaryQuery(comm.QUERY_XML, q);
			}

			return request;
		},

		onViewRootResponse: function(/*Response*/res) {
			// summary: if request was issued, then set result as new root node
			var node = res.getResultNode();
			if (!node || (node.$URL != this.urlRoot)) {
				this.setViewNode(node);
			}
		}
	});
});